export default {"src":"/_next/static/media/Spinner.e000ee9b.svg","height":397,"width":397};